import React, { useRef } from 'react'
import {Row, Col, Typography, Flex, Card, Rate, Space} from 'antd';
import Slider from 'react-slick';
import { motion, useScroll, useTransform } from 'framer-motion';

const { Title, Text, Paragraph } = Typography;
    function Testimonial() {

        // const targetRef = useRef(null)
        // const { scrollYProgress } = useScroll({
        //     target: targetRef,
        //     offset:["end end", "end start"]
        // })
        // const opacity = useTransform( scrollYProgress, [0, .5], [1, 0] )
        // const scale = useTransform( scrollYProgress, [0, .5], [1, .8] )

        const testimonialData = [
            {
                img: 't-1.jpg',
                title: 'John',
                desc: 'I accidentally stumbled upon framer while looking for another tool but I am very glad I did!.'
            },
            {
                img: 'deo.webp',
                title: 'Deo Jhon',
                desc: 'Such a clean, beautiful template and so easy to customise. Would highly recommend.'
            },
            {
                img: 'av-1.png',
                title: 'Anaya',
                desc: 'I never realized how much money i was wasting on unnecessary expenses until I started using Brixso.'
            },
            {
                img: 'rabica.webp',
                title: 'Rabica',
                desc: 'I accidentally stumbled upon framer while looking for another tool but I am very glad I did!.'
            },
            {
                img: 'smith.webp',
                title: 'Smith',
                desc: 'I accidentally stumbled upon framer while looking for another tool but I am very glad I did!.'
            },
            {
                img: 'jacksan.webp',
                title: 'Jacksan',
                desc: 'Such a clean, beautiful template and so easy to customise. Would highly recommend.'
            },
            {
                img: 'bedyani.webp',
                title: 'Bediyani',
                desc: 'I never realized how much money i was wasting on unnecessary expenses until I started using Brixso.'
            },
            {
                img: 't-3.png',
                title: 'Angelina',
                desc: 'I accidentally stumbled upon framer while looking for another tool but I am very glad I did!.'
            },
    
        ]

        var testimonialSlider = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            initialSlide: 0,
            centerMode: true,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: true,
            nextArrow: <img  src='/assets/icons/arrow-right.png' width={30}/>,
            prevArrow: <img  src='/assets/icons/arrow-right.png' width={30}/>,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  infinite: true,
                  dots: true,
                  arrows: false,
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  initialSlide: 0,
                  arrows: false,
                }
              },
              {
                breakpoint: 500,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  initialSlide: 0,
                  arrows: false,
                }
              }
            ]
          }

        return (
            <div className='padding-t-m bg-light'>
                <div className='container'>
                    <Row gutter={[24,24]} justify={'center'}>
                        <Col span={24}>
                            <Flex vertical justify='center' gap={10} align='center'>
                                <motion.div
                                    initial={{ opacity: 0}}
                                    whileInView={{
                                        opacity: 1
                                    }}
                                    transition={{ duration: 2, ease: 'easeInOut' }}
                                    viewport={{once: true}}
                                >
                                    <Title level={1} className='text-center gradient-text m-0'>
                                        Read what our clients <span className='bg-text'>saying</span>
                                    </Title>
                                </motion.div>
                                <motion.div
                                    initial={{ y: 100, opacity: 0 }}
                                    whileInView={{
                                        opacity: 1,
                                        y: 0,
                                    }}
                                    transition={{ delay: .5, duration: 2, type:'spring', stiffness: 300 }}
                                    viewport={{once: true}}
                                >
                                    <Text className='text-gray fs-16'>
                                        Don't take our word for it. Listen to our partners.
                                    </Text>
                                </motion.div>
                            </Flex>
                        </Col>
                        <Col span={24}>
                            <Slider {...testimonialSlider}>
                                {
                                    testimonialData?.map((data,index)=>{
                                        return(
                                            <div className='px-2'>
                                                <Card key={index}>
                                                     <Space direction='vertical' size={10} style={{ justifyContent: 'center', alignItems: 'center' }}>
                                                    <img src={'/assets/images/' + data?.img} width={35} height={35}  style={{borderRadius: 50,objectFit:'cover'}}  />
                                                    <Text className='fs-15 fw-500'>
                                                        {
                                                            data?.title
                                                        }
                                                    </Text>
                                                    <Rate defaultValue={5} />
                                                    <Paragraph
                                                        ellipsis={{
                                                            rows: 2,
                                                            expandable: true,
                                                        }}
                                                        title={data?.desc}
                                                        className='overflow-on m-0'
                                                    >
                                                        {data?.desc}
                                                    </Paragraph>
                                                    <img src="" alt="" />
                                                </Space>
                                                </Card>
                                            </div>
                                        )
                                    })
                                }
                            </Slider>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }

export {Testimonial}